"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ArrowDown = () => (react_1.default.createElement("svg", { width: "14", height: "8", viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M7 7L6.46967 7.53033C6.76256 7.82322 7.23744 7.82322 7.53033 7.53033L7 7ZM0.46967 1.53033L6.46967 7.53033L7.53033 6.46967L1.53033 0.46967L0.46967 1.53033ZM7.53033 7.53033L13.5303 1.53033L12.4697 0.46967L6.46967 6.46967L7.53033 7.53033Z", fill: "#21145A" })));
exports.default = ArrowDown;
